import React from 'react';

export const B1 = () => {
  return (
    <>
      {/* Frame 38 */}
      <div
        style={{
          position: 'absolute',
          width: 649,
          height: 432,
          left: 97,
          top: 182,
        }}
      >
        {/* Rectangle 3 */}
        <div
          style={{
            position: 'absolute',
            width: 649,
            height: 432,
            left: 0,
            top: 0,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.00707px 1.87056px 8.64px rgba(255,255,255,0.15),
              inset 1.07787px 1.00456px 4.32px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.88px)',
            borderRadius: 50,
            padding: '31px 30px 40px 30px',
            boxSizing: 'border-box',
          }}
        >
          {/* Title */}
          <div
            style={{
              position: 'absolute',
              left: 30,
              top: 31,
              width: 460,
              height: 152,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 64,
              lineHeight: '76px',
              color: '#FFFFFF',
            }}
          >
            Trade like a <span style={{ color: '#7F38F3' }}>Pro</span>
            <br />
            without the <span style={{ color: '#7F38F3' }}>guru</span>
          </div>

          {/* Description */}
          <div
            style={{
              position: 'absolute',
              left: 30,
              top: 193,
              width: 494,
              height: 141,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 24,
              lineHeight: '29px',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            AI-powered chart analysis that delivers actionable trade plans. Upload your charts and get instant insights for better trading decisions.
          </div>

          {/* Button */}
          <div
            style={{
              position: 'absolute',
              left: 30,
              top: 334,
              width: 346,
              height: 70,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 38,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontFamily: `'SF Pro', sans-serif`,
                fontStyle: 'normal',
                fontWeight: 510,
                fontSize: 40,
                lineHeight: '48px',
                color: '#FFFFFF',
              }}
            >
              Analyze a Chart
            </span>
          </div>
        </div>
      </div>
    </>
  );
};